package com.rosario.juridico.ui.screens

import androidx.compose.animation.*
import androidx.compose.animation.core.*
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.ClickableText
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Bolt
import androidx.compose.material.icons.filled.Close
import androidx.compose.material.icons.filled.Info
import androidx.compose.material.icons.filled.Lock
import androidx.compose.material.icons.filled.Warning
import androidx.compose.material3.*
import androidx.compose.material3.MaterialTheme.colorScheme
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.geometry.CornerRadius
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.zIndex
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.OffsetMapping
import androidx.compose.ui.text.input.TransformedText
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.zIndex
// Removed unused imports
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.ui.input.pointer.pointerInput
import androidx.navigation.NavController
import kotlinx.coroutines.launch
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import com.rosario.juridico.openEmail
import com.rosario.juridico.openPhone
import com.rosario.juridico.openWhatsApp
import com.rosario.juridico.domain.*
import com.rosario.juridico.platform.AccessResult
import com.rosario.juridico.platform.UserQuota
import com.rosario.juridico.platform.checkAccess
import com.rosario.juridico.platform.UserStatus as PlatformUserStatus
import com.rosario.juridico.isFirstTime
import com.rosario.juridico.setFirstTimeSeen
import com.rosario.juridico.ui.theme.Gold400

// ─────────────────────────────────────────────────────────────────────────────
// COMPONENTES FREEMIUM COMPARTIDOS
// ─────────────────────────────────────────────────────────────────────────────

@Composable
fun UsageCounterBadge(trialExpiresAt: Long) {
    val remainingText = getTrialRemainingText(trialExpiresAt)
    val isCritical = remainingText.contains("hora", true) || remainingText.contains("minutos", true)
    
    Surface(
        color = if (isCritical) Color(0xFFD32F2F) else Gold400,
        shape = RoundedCornerShape(16.dp),
        tonalElevation = 4.dp
    ) {
        Row(
            modifier = Modifier.padding(horizontal = 12.dp, vertical = 6.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Icon(Icons.Default.Bolt, null, tint = Color.White, modifier = Modifier.size(16.dp))
            Spacer(modifier = Modifier.width(4.dp))
            Text(
                remainingText,
                color = Color.White,
                fontSize = 12.sp,
                fontWeight = FontWeight.Bold
            )
        }
    }
}

fun getTrialRemainingText(trialExpiresAt: Long): String {
    val now = kotlinx.datetime.Clock.System.now().toEpochMilliseconds()
    val diff = trialExpiresAt - now
    if (diff <= 0) return "Prueba vencida"

    val hours = diff / (1000 * 60 * 60)
    val days = hours / 24

    return when {
        days >= 2 -> "Te quedan $days días de prueba gratuita"
        days == 1L -> "Quedan 24 horas de prueba gratuita"
        hours >= 1 -> "Te quedan $hours horas de prueba gratuita"
        else -> "Últimos minutos de prueba gratuita"
    }
}

@Composable
fun UsageLimitDialog(onDismiss: () -> Unit, onUpgrade: () -> Unit) {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(Color.Black.copy(alpha = 0.6f))
            .zIndex(100f)
            .pointerInput(Unit) { detectTapGestures {} },
        contentAlignment = Alignment.Center
    ) {
        Surface(
            modifier = Modifier
                .align(Alignment.Center)
                .fillMaxWidth(0.9f)
                .widthIn(max = 400.dp)
                .padding(16.dp),
            shape = RoundedCornerShape(24.dp),
            color = colorScheme.surface,
            tonalElevation = 6.dp,
            shadowElevation = 8.dp
        ) {
            Column(
                modifier = Modifier.padding(24.dp),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                Icon(
                    imageVector = Icons.Default.Lock,
                    contentDescription = null,
                    tint = colorScheme.primary,
                    modifier = Modifier.size(48.dp)
                )
                Text(
                    text = "Límite Alcanzado",
                    style = MaterialTheme.typography.titleLarge,
                    fontWeight = FontWeight.Bold,
                    color = colorScheme.onSurface
                )
                Text(
                    text = "Has agotado tus usos gratuitos. Suscribite a Premium para obtener acceso ilimitado a todas las calculadoras y funciones exclusivas.",
                    style = MaterialTheme.typography.bodyMedium,
                    color = colorScheme.onSurfaceVariant,
                    textAlign = TextAlign.Center
                )
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.End,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    TextButton(onClick = onDismiss) {
                        Text("Más tarde")
                    }
                    Spacer(modifier = Modifier.width(8.dp))
                    Button(onClick = onUpgrade) {
                        Text("Ver Planes Premium")
                    }
                }
            }
        }
    }
}

@Composable
fun RegistrationWallDialog(
    onDismiss: () -> Unit,
    onLoginClick: () -> Unit
) {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(Color.Black.copy(alpha = 0.6f))
            .zIndex(100f)
            .pointerInput(Unit) { detectTapGestures {} },
        contentAlignment = Alignment.Center
    ) {
        Surface(
            modifier = Modifier
                .align(Alignment.Center)
                .fillMaxWidth(0.9f)
                .widthIn(max = 400.dp)
                .padding(16.dp),
            shape = RoundedCornerShape(24.dp),
            color = colorScheme.surface,
            tonalElevation = 6.dp,
            shadowElevation = 8.dp
        ) {
            Column(
                modifier = Modifier.padding(24.dp),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                Surface(
                    color = colorScheme.primaryContainer,
                    shape = CircleShape,
                    modifier = Modifier.size(64.dp)
                ) {
                    Box(contentAlignment = Alignment.Center) {
                        Icon(
                            imageVector = Icons.Default.Lock,
                            contentDescription = null,
                            tint = colorScheme.primary,
                            modifier = Modifier.size(32.dp)
                        )
                    }
                }

                Text(
                    text = "Registro Requerido",
                    style = MaterialTheme.typography.titleLarge,
                    fontWeight = FontWeight.Bold,
                    color = colorScheme.onSurface,
                    textAlign = TextAlign.Center
                )

                Text(
                    text = "Para acceder a esta función y guardar tu progreso en la nube, es necesario iniciar sesión o crear una cuenta gratuita.",
                    style = MaterialTheme.typography.bodyMedium,
                    color = colorScheme.onSurfaceVariant,
                    textAlign = TextAlign.Center
                )

                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.End,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    TextButton(onClick = onDismiss) {
                        Text("Seguir explorando")
                    }
                    Spacer(modifier = Modifier.width(8.dp))
                    Button(onClick = onLoginClick) {
                        Text("Iniciar sesión / Registrarse")
                    }
                }
            }
        }
    }
}

@Composable
fun TrialActivationDialog(
    onDismiss: () -> Unit,
    onActivateTrial: () -> Unit
) {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(Color.Black.copy(alpha = 0.6f))
            .zIndex(100f)
            .pointerInput(Unit) { detectTapGestures {} },
        contentAlignment = Alignment.Center
    ) {
        Surface(
            modifier = Modifier
                .align(Alignment.Center)
                .fillMaxWidth(0.9f)
                .widthIn(max = 400.dp)
                .padding(16.dp),
            shape = RoundedCornerShape(24.dp),
            color = colorScheme.surface,
            tonalElevation = 6.dp,
            shadowElevation = 8.dp
        ) {
            Column(
                modifier = Modifier.padding(24.dp),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                Surface(
                    color = Gold400.copy(alpha = 0.2f),
                    shape = CircleShape,
                    modifier = Modifier.size(64.dp)
                ) {
                    Box(contentAlignment = Alignment.Center) {
                        Icon(
                            imageVector = Icons.Default.Bolt,
                            contentDescription = null,
                            tint = Gold400,
                            modifier = Modifier.size(32.dp)
                        )
                    }
                }

                Text(
                    text = "Activar Prueba Gratuita",
                    style = MaterialTheme.typography.titleLarge,
                    fontWeight = FontWeight.Bold,
                    color = colorScheme.onSurface,
                    textAlign = TextAlign.Center
                )

                Text(
                    text = "Obtené acceso ilimitado a todas las funciones profesionales y calculadoras avanzadas durante tu período de prueba.",
                    style = MaterialTheme.typography.bodyMedium,
                    color = colorScheme.onSurfaceVariant,
                    textAlign = TextAlign.Center
                )

                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.End,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    TextButton(onClick = onDismiss) {
                        Text("Más tarde")
                    }
                    Spacer(modifier = Modifier.width(8.dp))
                    Button(onClick = onActivateTrial) {
                        Text("Activar Prueba")
                    }
                }
            }
        }
    }
}

// ─────────────────────────────────────────────────────────────────────────────
// VISUAL TRANSFORMATION — separador de miles
// ─────────────────────────────────────────────────────────────────────────────

class ThousandSeparatorVisualTransformation : VisualTransformation {
    override fun filter(text: AnnotatedString): TransformedText {
        val originalText = text.text
        if (originalText.isEmpty()) return TransformedText(text, OffsetMapping.Identity)

        val sb = StringBuilder()
        val mapping = IntArray(originalText.length + 1)

        var i = 0
        while (i < originalText.length) {
            if (originalText[i].isDigit()) {
                val start = i
                while (i < originalText.length && originalText[i].isDigit()) {
                    i++
                }
                val end = i
                val digits = originalText.substring(start, end)

                for (j in digits.indices) {
                    mapping[start + j] = sb.length
                    sb.append(digits[j])
                    val remaining = digits.length - 1 - j
                    if (remaining > 0 && remaining % 3 == 0) {
                        sb.append('.')
                    }
                }
            } else {
                mapping[i] = sb.length
                sb.append(originalText[i])
                i++
            }
        }
        mapping[originalText.length] = sb.length

        val transformedText = sb.toString()

        val offsetMapping = object : OffsetMapping {
            override fun originalToTransformed(offset: Int): Int =
                if (offset >= mapping.size) transformedText.length else mapping[offset.coerceAtLeast(0)]

            override fun transformedToOriginal(offset: Int): Int {
                var bestOriginal = 0
                for (idx in mapping.indices) {
                    if (mapping[idx] <= offset) bestOriginal = idx
                    else break
                }
                return bestOriginal
            }
        }

        return TransformedText(AnnotatedString(transformedText), offsetMapping)
    }
}

// ─────────────────────────────────────────────────────────────────────────────
// EXTENSIÓN PARA FORMATO
// ─────────────────────────────────────────────────────────────────────────────

fun Double.toFormato(decimales: Int, usarSeparadorMiles: Boolean = false): String {
    if (this.isNaN()) return "0,00"
    if (this.isInfinite()) return this.toString()

    val esNegativo = this < 0
    val valorAbs = if (esNegativo) -this else this

    var factor = 1.0
    repeat(decimales) { factor *= 10.0 }

    val totalUnidadesMinimas = kotlin.math.round(valorAbs * factor).toLong()
    val factorLong = factor.toLong().coerceAtLeast(1L)

    var entera = (totalUnidadesMinimas / factorLong).toString()
    val decimalVal = totalUnidadesMinimas % factorLong

    if (usarSeparadorMiles) {
        val sb = StringBuilder()
        entera.reversed().forEachIndexed { index, c ->
            if (index > 0 && index % 3 == 0) sb.append('.')
            sb.append(c)
        }
        entera = sb.toString().reversed()
    }

    val prefijo = if (esNegativo) "-" else ""
    return if (decimales > 0) {
        val decimalStr = decimalVal.toString().padStart(decimales, '0')
        "$prefijo$entera,$decimalStr"
    } else {
        "$prefijo$entera"
    }
}

fun Double.toPesos(): String = "$ ${this.toFormato(2, true)}"
fun Double.toPorcentaje(): String = "${(this * 100).toFormato(2)} %"
fun Double.toPorcentajeDirecto(): String = "${this.toFormato(2)} %"

fun LocalDate.toTexto(): String {
    val d = dayOfMonth.toString().padStart(2, '0')
    val m = monthNumber.toString().padStart(2, '0')
    return "$d/$m/$year"
}

fun LocalDate.toMesAnio(): String {
    val m = monthNumber.toString().padStart(2, '0')
    return "$m/$year"
}

@Composable
fun TrialActionLock(
    onAction: () -> Unit,
    navController: NavController,
    content: @Composable (onClick: () -> Unit) -> Unit
) {
    val accessState = AppUsageManager.instance.checkAccess()
    val isTrialExpired = accessState == AccessState.EXPIRED

    content {
        when {
            isTrialExpired -> {
                navController.navigate(com.rosario.juridico.navigation.Routes.PAYWALL)
            }
            else -> {
                onAction()
            }
        }
    }
}

@Composable
fun CalculatorActionLock(
    onAction: () -> Unit,
    navController: NavController,
    modifier: Modifier = Modifier,
    content: @Composable (onClick: () -> Unit) -> Unit
) {
    // Escucha de flujo reactivo directo de AppUsageManager y PremiumManager para recomposición instantánea
    val userStatus by AppUsageManager.instance.userStatus.collectAsState()
    val scope = rememberCoroutineScope()
    
    // Verificación de estado Premium unificada desde el estado reactivo consolidado
    val isPremium = userStatus.isPremium

    // Auditoría Fase 2: Cierre de fuga nivel visitante
    val isAnonymous = com.rosario.juridico.platform.FirebaseProxy.isAnonymous()

    var showLimitDialog by remember { mutableStateOf(false) }
    var showRegisterDialog by remember { mutableStateOf(false) }

    Box(modifier = modifier) {
        content {
            when {
                // Evaluación de anónimo/deslogueado prevalece sobre cualquier otra regla
                isAnonymous || !com.rosario.juridico.platform.FirebaseProxy.isLoggedIn() -> {
                    showRegisterDialog = true
                }
                // Prioridad absoluta a los que ya tienen acceso ilimitado
                isPremium -> {
                    onAction()
                }
                else -> {
                    // Usuario registrado con sistema de cuotas
                    scope.launch {
                        val hasAccess = AppUsageManager.instance.checkAndConsumeUsage()
                        if (hasAccess) {
                            onAction()
                        } else {
                            // Bloqueo: Mostrar diálogo que lleva al Paywall (Regla de Negocio 2)
                            showLimitDialog = true
                        }
                    }
                }
            }
        }

        // Custom Overlay para Visitantes (Anónimos)
        if (showRegisterDialog) {
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(Color.Black.copy(alpha = 0.6f))
                    .zIndex(100f)
                    .pointerInput(Unit) { detectTapGestures {} },
                contentAlignment = Alignment.Center
            ) {
                Surface(
                    modifier = Modifier
                        .fillMaxWidth(0.9f)
                        .widthIn(max = 400.dp)
                        .padding(16.dp),
                    shape = RoundedCornerShape(24.dp),
                    color = colorScheme.surface,
                    tonalElevation = 6.dp,
                    shadowElevation = 8.dp
                ) {
                    Column(
                        modifier = Modifier.padding(24.dp),
                        horizontalAlignment = Alignment.CenterHorizontally,
                        verticalArrangement = Arrangement.spacedBy(16.dp)
                    ) {
                        Text(
                            text = "Registro Requerido",
                            style = MaterialTheme.typography.titleLarge,
                            fontWeight = FontWeight.Bold,
                            color = colorScheme.onSurface
                        )
                        Text(
                            text = "Registrate gratis con tu email para obtener 5 usos de prueba y sincronizar tus datos en todos tus dispositivos.",
                            style = MaterialTheme.typography.bodyMedium,
                            color = colorScheme.onSurfaceVariant,
                            textAlign = TextAlign.Center
                        )
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.End,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            TextButton(onClick = { showRegisterDialog = false }) {
                                Text("Más tarde")
                            }
                            Spacer(modifier = Modifier.width(8.dp))
                            Button(onClick = {
                                com.rosario.juridico.platform.AnalyticsLogger.logEvent("visitor_blocked", mapOf("target" to "registration"))
                                showRegisterDialog = false
                                
                                // Capturamos la ruta donde saltó el muro para volver tras loguearse (Seamless UX)
                                val currentRoute = navController.currentBackStackEntry?.destination?.route
                                if (currentRoute != null) {
                                    com.rosario.juridico.domain.AppUsageManager.pendingRoute = currentRoute
                                }
                                
                                navController.navigate(com.rosario.juridico.navigation.Routes.login(register = true))
                            }) {
                                Text("Registrarme Gratis")
                            }
                        }
                    }
                }
            }
        }

        // Custom Overlay para Usuarios Registrados (Freemium agotado)
        if (showLimitDialog) {
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(Color.Black.copy(alpha = 0.6f))
                    .zIndex(100f)
                    .pointerInput(Unit) { detectTapGestures {} },
                contentAlignment = Alignment.Center
            ) {
                Surface(
                    modifier = Modifier
                        .fillMaxWidth(0.9f)
                        .widthIn(max = 400.dp)
                        .padding(16.dp),
                    shape = RoundedCornerShape(24.dp),
                    color = colorScheme.surface,
                    tonalElevation = 6.dp,
                    shadowElevation = 8.dp
                ) {
                    Column(
                        modifier = Modifier.padding(24.dp),
                        horizontalAlignment = Alignment.CenterHorizontally,
                        verticalArrangement = Arrangement.spacedBy(16.dp)
                    ) {
                        Text(
                            text = "Límite Alcanzado",
                            style = MaterialTheme.typography.titleLarge,
                            fontWeight = FontWeight.Bold,
                            color = colorScheme.onSurface
                        )
                        Text(
                            text = "Alcanzaste tu límite de cálculos gratuitos. Hazte Premium para obtener acceso ilimitado en el celular y la PC.",
                            style = MaterialTheme.typography.bodyMedium,
                            color = colorScheme.onSurfaceVariant,
                            textAlign = TextAlign.Center
                        )
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.End,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            TextButton(onClick = { showLimitDialog = false }) {
                                Text("Más tarde")
                            }
                            Spacer(modifier = Modifier.width(8.dp))
                            Button(onClick = {
                                com.rosario.juridico.platform.AnalyticsLogger.logEvent("paywall_viewed", mapOf("origin" to "calculator_limit"))
                                showLimitDialog = false
                                navController.navigate(com.rosario.juridico.navigation.Routes.PAYWALL)
                            }) {
                                Text("Hazte Premium")
                            }
                        }
                    }
                }
            }
        }
    }
}

@Composable
fun UsageCounterIndicator(modifier: Modifier = Modifier) {
    val userStatus by AppUsageManager.instance.userStatus.collectAsState()
    val accessState = AppUsageManager.instance.checkAccess()
    val isPremium = accessState == AccessState.PREMIUM_ACTIVE
    
    // Si es premium, no mostramos el contador (Fase 3: Limpieza visual)
    if (isPremium) return

    val quota = UserQuota(
        initial_uses_remaining = userStatus.initial_uses_remaining,
        last_monthly_use_timestamp = userStatus.last_monthly_use_timestamp
    )
    val accessResult = checkAccess(quota)
    
    val message = when (accessResult) {
        AccessResult.ALLOWED_INITIAL -> "Usos iniciales gratuitos: ${userStatus.initial_uses_remaining} de 5"
        AccessResult.ALLOWED_MONTHLY -> "Uso de cortesía mensual disponible"
        AccessResult.DENIED -> "Límite alcanzado (Próximo uso en 30 días)"
    }

    Surface(
        color = if (accessResult != AccessResult.DENIED) MaterialTheme.colorScheme.secondaryContainer.copy(alpha = 0.5f) else MaterialTheme.colorScheme.errorContainer.copy(alpha = 0.8f),
        shape = RoundedCornerShape(8.dp),
        modifier = modifier.padding(horizontal = 16.dp, vertical = 4.dp)
    ) {
        Row(
            modifier = Modifier.padding(horizontal = 12.dp, vertical = 6.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Icon(
                imageVector = if (accessResult != AccessResult.DENIED) Icons.Default.Info else Icons.Default.Warning,
                contentDescription = null,
                modifier = Modifier.size(14.dp),
                tint = if (accessResult != AccessResult.DENIED) MaterialTheme.colorScheme.primary else MaterialTheme.colorScheme.error
            )
            Spacer(modifier = Modifier.width(8.dp))
            Text(
                text = message,
                style = MaterialTheme.typography.labelSmall,
                fontWeight = FontWeight.Bold,
                color = if (accessResult != AccessResult.DENIED) MaterialTheme.colorScheme.onSecondaryContainer else MaterialTheme.colorScheme.onErrorContainer
            )
        }
    }
}

fun String.normalized(): String {
    return this
        .replace('á', 'a').replace('é', 'e').replace('í', 'i')
        .replace('ó', 'o').replace('ú', 'u').replace('ü', 'u')
        .replace('Á', 'A').replace('É', 'E').replace('Í', 'I')
        .replace('Ó', 'O').replace('Ú', 'U').replace('ñ', 'n').replace('Ñ', 'N')
        .lowercase()
}

@Composable
fun rememberFormattedDate(timestamp: Long): String {
    return remember(timestamp) {
        if (timestamp <= 0) "Indefinido"
        else {
            try {
                val instant = kotlinx.datetime.Instant.fromEpochMilliseconds(timestamp)
                val dateTime = instant.toLocalDateTime(TimeZone.currentSystemDefault())
                val d = dateTime.dayOfMonth.toString().padStart(2, '0')
                val m = dateTime.monthNumber.toString().padStart(2, '0')
                val y = dateTime.year
                "$d/$m/$y"
            } catch (e: Exception) {
                "N/A"
            }
        }
    }
}

expect fun copiarAlPortapapeles(label: String, texto: String)

@Composable
fun TextoInteractivoAI(texto: String) {
    val regexUrlPlana = Regex("""\b(https?://|www\.)[^\s/$.?#].[^\s]*""")
    val regexEmail    = Regex("""\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b""")
    val regexTelefono = Regex("""(\+?\d{1,3}[\s-]?)?\(?\d{2,4}\)?[\s-]?\d{3,4}[\s-]?\d{4}""")

    var textoLimpio = texto
        .replace(Regex("<br/?>", RegexOption.IGNORE_CASE), "\n")
        .replace(Regex("</?b>", RegexOption.IGNORE_CASE), "")
        .replace(Regex("</?i>", RegexOption.IGNORE_CASE), "")
        .replace(Regex("""\*\*"""), "")
        .replace(Regex("""__"""), "")
        .replace(Regex("""\[([^\]]+)\]\(([^)]+)\)""")) { it.groupValues[1] }
        .replace(Regex("""<a\s+href="([^"]+)">([^<]+)</a>""")) { it.groupValues[2] }

    val textoAnotado = buildAnnotatedString {
        append(textoLimpio)
        regexUrlPlana.findAll(textoLimpio).forEach { m ->
            val url = if (!m.value.startsWith("http")) "https://${m.value}" else m.value
            addStringAnnotation("URL", url, m.range.first, m.range.last + 1)
            addStyle(SpanStyle(color = Color(0xFF005AC1), textDecoration = TextDecoration.Underline), m.range.first, m.range.last + 1)
        }
        regexEmail.findAll(textoLimpio).forEach { m ->
            addStringAnnotation("EMAIL", m.value, m.range.first, m.range.last + 1)
            addStyle(SpanStyle(color = Color(0xFF005AC1), textDecoration = TextDecoration.Underline), m.range.first, m.range.last + 1)
        }
        regexTelefono.findAll(textoLimpio).forEach { m ->
            addStringAnnotation("TEL", m.value, m.range.first, m.range.last + 1)
            addStyle(SpanStyle(color = colorScheme.primary, textDecoration = TextDecoration.Underline), m.range.first, m.range.last + 1)
        }
    }

    SelectionContainer {
        ClickableText(
            text  = textoAnotado,
            style = androidx.compose.ui.text.TextStyle.Default.copy(
                color    = colorScheme.onSurface,
                fontSize = 15.sp
            ),
            onClick = { offset ->
                textoAnotado.getStringAnnotations("URL", offset, offset).firstOrNull()?.let {
                    openWhatsApp(it.item)
                }
                textoAnotado.getStringAnnotations("EMAIL", offset, offset).firstOrNull()?.let {
                    openEmail(it.item)
                }
                textoAnotado.getStringAnnotations("TEL", offset, offset).firstOrNull()?.let {
                    openPhone(it.item)
                }
            }
        )
    }
}

@Composable
fun BotonPrincipal(texto: String, onClick: () -> Unit, icono: Painter? = null) {
    val isDark = isSystemInDarkTheme()
    Button(
        onClick        = onClick,
        modifier       = Modifier.fillMaxWidth().padding(vertical = 5.dp),
        shape          = RoundedCornerShape(12.dp),
        colors         = ButtonDefaults.buttonColors(containerColor = colorScheme.surfaceVariant, contentColor = colorScheme.onSurfaceVariant),
        border         = BorderStroke(1.dp, if (isDark) colorScheme.outline.copy(alpha = 0.6f) else colorScheme.outline.copy(alpha = 0.35f)),
        contentPadding = PaddingValues(horizontal = 20.dp, vertical = 16.dp),
        elevation      = ButtonDefaults.buttonElevation(defaultElevation = 2.dp)
    ) {
        Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.Start, modifier = Modifier.fillMaxWidth()) {
            if (icono != null) {
                Icon(icono, contentDescription = null, modifier = Modifier.size(22.dp))
                Spacer(modifier = Modifier.width(16.dp))
            }
            Text(texto, style = MaterialTheme.typography.bodyLarge, fontWeight = FontWeight.Medium)
        }
    }
}

@Composable
fun AvisoIA() {
    Card(modifier = Modifier.fillMaxWidth(), shape = RoundedCornerShape(10.dp), colors = CardDefaults.cardColors(containerColor = colorScheme.surfaceVariant)) {
        Row(modifier = Modifier.padding(12.dp), verticalAlignment = Alignment.Top) {
            Text("⚠️", modifier = Modifier.padding(top = 1.dp, end = 8.dp))
            Text(
                "Esta respuesta es generada por IA y no constituye asesoramiento legal profesional. Consultá siempre a un abogado matriculado.",
                style = MaterialTheme.typography.bodySmall,
                color = colorScheme.onSurfaceVariant
            )
        }
    }
}

@Composable
fun Modifier.resaltadoGuia(activado: Boolean): Modifier {
    if (!activado) return this

    val infiniteTransition = rememberInfiniteTransition(label = "resaltadoGuia")
    val colorOro   = Color(0xFFFFD700)
    val colorAmbar = Color(0xFFFF8C00)
    val totalDuration = 8000

    val pulseAlpha by infiniteTransition.animateFloat(
        initialValue = 0.20f,
        targetValue  = 0.20f,
        animationSpec = infiniteRepeatable(
            animation = keyframes {
                durationMillis = totalDuration
                0.20f at 0 with FastOutSlowInEasing
                1.00f at 300 with FastOutSlowInEasing
                0.20f at 600 with FastOutSlowInEasing
                0.80f at 1000 with FastOutSlowInEasing
                0.20f at 1400 with FastOutSlowInEasing
                0.40f at 5000 with LinearOutSlowInEasing
                0.20f at 8000 with LinearOutSlowInEasing
            }
        ),
        label = "pulseAlpha"
    )

    val glowWidthPx by infiniteTransition.animateFloat(
        initialValue = 3f,
        targetValue  = 3f,
        animationSpec = infiniteRepeatable(
            animation = keyframes {
                durationMillis = totalDuration
                3f at 0 with FastOutSlowInEasing
                18f at 300 with FastOutSlowInEasing
                3f at 600 with FastOutSlowInEasing
                14f at 1000 with FastOutSlowInEasing
                3f at 1400 with FastOutSlowInEasing
                7f at 5000 with LinearOutSlowInEasing
                3f at 8000 with LinearOutSlowInEasing
            }
        ),
        label = "glowWidth"
    )

    return this
        .drawBehind {
            val radius   = 12.dp.toPx()
            val expandPx = glowWidthPx
            val expand1 = expandPx * 1.8f
            drawRoundRect(
                color        = colorAmbar.copy(alpha = pulseAlpha * 0.25f),
                topLeft      = Offset(-expand1, -expand1),
                size         = Size(size.width + expand1 * 2f, size.height + expand1 * 2f),
                cornerRadius = CornerRadius(radius + expand1),
                style        = Stroke(width = expandPx * 1.2f)
            )
            val expand2 = expandPx * 0.9f
            drawRoundRect(
                color        = colorOro.copy(alpha = pulseAlpha * 0.50f),
                topLeft      = Offset(-expand2, -expand2),
                size         = Size(size.width + expand2 * 2f, size.height + expand2 * 2f),
                cornerRadius = CornerRadius(radius + expand2),
                style        = Stroke(width = expandPx * 0.6f)
            )
            drawRoundRect(
                color        = colorOro.copy(alpha = pulseAlpha * 0.80f),
                cornerRadius = CornerRadius(radius),
                style        = Stroke(width = expandPx * 0.30f)
            )
            drawRoundRect(
                color        = colorOro.copy(alpha = pulseAlpha * 0.08f),
                cornerRadius = CornerRadius(radius)
            )
        }
        .border(
            width  = 2.2.dp,
            color  = colorOro.copy(alpha = (pulseAlpha * 0.60f + 0.35f).coerceIn(0f, 1f)),
            shape  = RoundedCornerShape(12.dp)
        )
        .padding(4.dp)
}

@Composable
fun OnboardingTooltip(
    key: String,
    mensaje: String,
    modifier: Modifier = Modifier
) {
    var visible by remember { mutableStateOf(isFirstTime(key)) }
    if (visible) {
        Box(
            modifier = modifier
                .fillMaxWidth()
                .padding(horizontal = 16.dp, vertical = 8.dp)
                .zIndex(10f)
        ) {
            Card(
                colors = CardDefaults.cardColors(
                    containerColor = colorScheme.secondaryContainer,
                    contentColor   = colorScheme.onSecondaryContainer
                ),
                elevation = CardDefaults.cardElevation(defaultElevation = 6.dp),
                shape     = RoundedCornerShape(12.dp),
                modifier  = Modifier.fillMaxWidth()
            ) {
                Column(modifier = Modifier.padding(12.dp)) {
                    Row(
                        verticalAlignment        = Alignment.CenterVertically,
                        horizontalArrangement    = Arrangement.SpaceBetween,
                        modifier                 = Modifier.fillMaxWidth()
                    ) {
                        Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.weight(1f)) {
                            Icon(
                                imageVector     = Icons.Default.Info,
                                contentDescription = null,
                                modifier        = Modifier.size(16.dp),
                                tint            = colorScheme.primary
                            )
                            Spacer(Modifier.width(8.dp))
                            Text(
                                text       = "Guía rápida",
                                style      = MaterialTheme.typography.labelMedium,
                                fontWeight = FontWeight.Bold,
                                color      = colorScheme.primary
                            )
                        }
                        IconButton(
                            onClick  = { visible = false },
                            modifier = Modifier.size(24.dp)
                        ) {
                            Icon(Icons.Default.Close, contentDescription = "Cerrar", modifier = Modifier.size(16.dp))
                        }
                    }
                    Spacer(Modifier.height(4.dp))
                    Text(
                        text       = mensaje,
                        style      = MaterialTheme.typography.bodySmall,
                        lineHeight = 16.sp
                    )
                    Spacer(Modifier.height(8.dp))
                    TextButton(
                        onClick         = { setFirstTimeSeen(key); visible = false },
                        modifier        = Modifier.align(Alignment.End),
                        contentPadding  = PaddingValues(horizontal = 12.dp, vertical = 4.dp)
                    ) {
                        Text("No volver a mostrar", style = MaterialTheme.typography.labelLarge, fontWeight = FontWeight.Bold)
                    }
                }
            }
        }
    }
}